/**
 * Form Styled Components
 * Reusable form elements with LinkedIn Blue theme
 */

import styled from 'styled-components';

export const FormField = styled.div`
  margin-bottom: 16px;

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #2C3E50;
    font-size: 14px;
  }

  input,
  textarea,
  select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #D0D7DE;
    border-radius: 4px;
    font-size: 14px;
    font-family: inherit;
    background: white;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: #0077B5;
      box-shadow: 0 0 0 2px rgba(0, 119, 181, 0.1);
    }

    &:disabled {
      background: #F3F6F8;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  textarea {
    min-height: 100px;
    resize: vertical;
  }

  small {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: #666666;
  }

  .error {
    color: #C0392B;
    font-size: 12px;
    margin-top: 4px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 24px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

